import './PaymentMethodIcon.sass';

import React, { FC, ReactNode, useMemo } from 'react';
import { IcTon56, IcVisa56, IcMastercard56, IcMir56, IcCard56, IcCryptoCurrency56 } from '$assets';
import { PaymentMethodIconProps } from './PaymentMethodIcon.interface';

export const PaymentMethodIcon: FC<PaymentMethodIconProps> = ({ method }) => {
  const Icon = () => {
    switch (method) {
      case 'visa':
        return <IcVisa56 />;
      case 'mastercard':
        return <IcMastercard56 />;
      case 'mir':
        return <IcMir56 />;
      case 'ton':
        return <IcTon56 />;
      case 'cryptocurrency':
        return <IcCryptoCurrency56 />;
      default:
        return <IcCard56 />;
    }
  };

  return (
    <div className="PaymentMethodIcon">
      <Icon />
    </div>
  );
}
